import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checkMark71C184",
  "use": "checkMark71C184-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"checkMark71C184\"><path d=\"M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12z\" fill=\"#71C184\" /><path d=\"M9.105 3.541a.339.339 0 0 0-.478.032L5.017 7.7l-1.65-1.762a.34.34 0 0 0-.495.464l1.91 2.035a.34.34 0 0 0 .247.107.337.337 0 0 0 .25-.116L9.135 4.02a.338.338 0 0 0-.03-.479z\" fill=\"#fff\" stroke=\"#fff\" stroke-width=\".2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol